import { Injectable, signal } from '@angular/core'

export interface VpnDetails {
	access?: string
	ip?: string
	network_type?: string
	proxy_type?: string
	reference_id?: string
	time?: string
}

export interface VpnErrorResponse {
	code?: string
	details?: VpnDetails
	error?: string
}

export const VPN_STORAGE_KEY = 'vpn_blocked_info'

@Injectable({
	providedIn: 'root',
})
export class VpnBlockedService {
	private readonly vpnInfo = signal<VpnErrorResponse | null>(this.getStoredInfo())

	readonly vpnInfo$ = this.vpnInfo.asReadonly()

	setVpnInfo(info: VpnErrorResponse): void {
		this.vpnInfo.set(info)
		try {
			sessionStorage.setItem(VPN_STORAGE_KEY, JSON.stringify(info))
		} catch {
			// ignore storage errors
		}
	}

	getVpnInfo(): VpnErrorResponse | null {
		return this.vpnInfo() || this.getStoredInfo()
	}

	clearVpnInfo(): void {
		this.vpnInfo.set(null)
		try {
			sessionStorage.removeItem(VPN_STORAGE_KEY)
		} catch {
			// ignore storage errors
		}
	}

	private getStoredInfo(): VpnErrorResponse | null {
		try {
			const data = sessionStorage.getItem(VPN_STORAGE_KEY)
			return data ? (JSON.parse(data) as VpnErrorResponse) : null
		} catch {
			return null
		}
	}
}
